import React, { useState, useEffect } from 'react';
import { Modal } from '@material-ui/core';
import { useSelector } from 'react-redux';
import _ from 'lodash';

import './ContentModal.scss';
import Icon from '../Icon/Icon';
import { RootState } from '../../configs/store';
import Banner from '../Banner/Banner/Banner';
import useCheckProduct from '../../hooks/useCheckProduct';
import useCheckDatetime from '../../hooks/useCheckDatetime';
import useCheckContentVisibility from '../../hooks/useCheckContentVisibility';

interface ContentModalProps {
  preview?: boolean,
  modal?: any,
  data?: {
    modals: any
  }
}

export default function ContentModal(data: ContentModalProps) {
  const { justLoggedIn } = useSelector((state: RootState) => state.auth);
  const localStorageModals = JSON.parse(localStorage.getItem('modals'));
  const contentModal = data.preview ? data.data.modals[0] : data.modal;
  const checkProduct = useCheckProduct(contentModal);
  const checkDatetime = useCheckDatetime(contentModal);
  const checkVisibility = useCheckContentVisibility(contentModal);
  const showIfBelowNrTime = _.has(localStorageModals, contentModal.id) && localStorageModals[contentModal.id].times < contentModal.showNrTime;
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    if (contentModal.trigger === 'onLoad' && (showIfBelowNrTime || !_.has(localStorageModals, contentModal.id))) {
      setIsOpen(true);
    }

    if (data.preview) {
      setIsOpen(true);
    }
  }, [contentModal]);

  useEffect(() => {
    if (contentModal.trigger === 'onLogin' && justLoggedIn && (showIfBelowNrTime || !_.has(localStorageModals, contentModal.id))) {
      setIsOpen(true);
    }
  }, [justLoggedIn]);

  const onClose = () => {
    localStorage.setItem('modals', JSON.stringify({
      ...localStorageModals,
      [contentModal.id]: {
        times: _.has(localStorageModals, contentModal.id) ? localStorageModals[contentModal.id].times + 1 : 1
      }
    }));

    setIsOpen(false);
  };

  if (checkVisibility && checkProduct && checkDatetime) {
    return (
      <Modal
        disableEscapeKeyDown={ true }
        open={ isOpen }
        onClose={ onClose }
      >
        <div className="content-modal">
          <Icon icon="close" className="content-modal__close" onClick={ onClose } />
          <Banner data={ contentModal.banner } />
        </div>
      </Modal>
    );
  }

  return null;
}
